/** Styl tabulky k tématu Erma */
export const DatatableStyles = {
  header: {
    cell: {
      background: '#f4f4f4',
      padding: '.3rem .6rem',
      borderColor: 'var(--erma-secondary-220)',
      hover: {
        background: '#e0e0e0',
        color: '#333'
      },
      selected: {
        background: 'var(--erma-primary-500)',
        color: 'var(--erma-primary-0)',
        borderColor: 'var(--erma-secondary-220)',
      }
    },
    extend: {
      marginBottom: '0',
      border: {
        header: {
          width: '1px 0px 1px 1px',
          last: {
            width: '1px 1px 1px 1px'
          }
        },
        body: {
          width: '0px 0px 1px 1px',
          last: {
            width: '0px 1px 1px 1px',
          }
        }
      }
    }
  },
  column: {
    title: {
      font: {
        weight: '700'
      }
    }
  },
  row: {
    stripedBackground: 'var(--erma-secondary-20)',
    selected: {
      background: 'var(--erma-primary-500)',
      color: 'var(--erma-primary-0)'
    }
  },
  body: {
    cell: {
      borderColor: '#c8c8c8',
      padding: '.3rem .6rem',
      selected: {
        borderColor: 'var(--erma-secondary-220)'
      }
    }
  },
  sort: {
    icon: {
      color: '#848484',
      hover: {
        color: 'var(--erma-primary-100)'
      }
    }
  },
  css: ({ dt }) => `
        table.p-datatable-table {
          margin-bottom:  ${dt('datatable.marginBottom')};
        }
        table .p-datatable-thead > tr > th {
          border-width:  ${dt('datatable.header.border.header.width')};
        }
        table .p-datatable-thead > tr > th:last-child{
          border-width:  ${dt('datatable.header.border.header.last.width')};
        }
        table .p-datatable-tbody > tr > td {
          border-width:  ${dt('datatable.header.border.body.width')};
        }
        table .p-datatable-tbody > tr > td:last-child {
          border-width:  ${dt('datatable.header.border.body.last.width')};
        }`
};
